/**
 * @generated SignedSource<<e77c9415e5babe9fb4261608ea5945bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AssignmentCancelMutation$variables = {
  assignmentId: string;
};
export type AssignmentCancelMutation$data = {
  readonly cancelAssignment: {
    readonly assignmentNode: {
      readonly id: string;
    } | null | undefined;
  };
};
export type AssignmentCancelMutation = {
  response: AssignmentCancelMutation$data;
  variables: AssignmentCancelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "assignmentId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "assignmentId",
            "variableName": "assignmentId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "CancelAssignmentPayload",
    "kind": "LinkedField",
    "name": "cancelAssignment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AssignmentNode",
        "kind": "LinkedField",
        "name": "assignmentNode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignmentCancelMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssignmentCancelMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "303eb56895b7a64cd92ac453c7167196",
    "id": null,
    "metadata": {},
    "name": "AssignmentCancelMutation",
    "operationKind": "mutation",
    "text": "mutation AssignmentCancelMutation(\n  $assignmentId: ID!\n) {\n  cancelAssignment(input: {assignmentId: $assignmentId}) {\n    assignmentNode {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8f9beb51755622d7b507eede4ed03193";

export default node;
